import React, { useEffect, useState } from "react";
import { BodyView, ButtonView, InputView, HeaderTitleView } from "../factory/ViewUtil";
import { NavBar } from "antd-mobile";
import { AlertContent, AlertContentAction, ToastClear, ToastContent, ToastLoading } from "../factory/FactoryUtil";
import { H5Login, UpdatePassword } from "../../NetworkFactory";

const ForgotCodeViewController = ({goback, gohome, data}) => {
    const {id, email} = data
    const [code, setCode] = useState('')
    const [password, setPassword] = useState('')

    const showError = () => {
        ToastContent(' Network or Unknown error')
    }

    const errorGoBack = (title = '') => {
        AlertContentAction(title, () => {
            goback()
        })
    }
    
    const goLogin = () => {
        H5Login(email, password).then(code => {
            if(code === 200) {
                ToastContent('Login Success')
            } else {
                ToastContent('Abnormal')
            }
            gohome()
        })
    }

    const done = () => {
        if(code.length < 6 || code.length > 10) {
            ToastContent('Invalid verification code')
            return
        }
        if(password.length < 6 || password.length > 20) {
            ToastContent('Valid password length 6-20')
            return
        }
        ToastLoading('Updating...')
        UpdatePassword(id, code, email, password).then(response => {
            ToastClear()
            const {status} = response.data || {}
            if(status === 200) {
                goLogin()
            }
            else if(status === -1) {
                errorGoBack('The verification code has expired')
            }
            else if(status === -2) {
                errorGoBack('Device model mismatch')
            }
            else if(status === -3) {
                AlertContent('Verification code error')
            }
            else if(status === -4) {
                errorGoBack('User not found')
            }
            else {
                showError()
            }

        }).catch(_ => {
            ToastClear()
            showError()
        })
    }

    useEffect(()=> {
        if(!id || !email) {
            ToastContent('Error')
            gohome()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    
    return(
        <>
            <NavBar onBack={goback}></NavBar>
            <BodyView>
                <HeaderTitleView>We will send the email <br/>verification code to your email</HeaderTitleView>
                <InputView value={code} onChange={val => {setCode(val)}} title='Email Code' type='number' clearable/>
                <div style={{margin : '20px 0 0 0'}}>
                    <InputView type='password' value={password} onChange={val => {setPassword(val)}} title='New password' clearable/>
                </div>
                <ButtonView onClick={done} style={{ width : '100%', marginTop: '30px'}}>Done</ButtonView>
            </BodyView>
        </>
    )
}

export default React.memo(ForgotCodeViewController)